

import { Component, Vue, Prop } from "vue-property-decorator"
import { Getter, namespace, State } from "vuex-class"

import { Area, AreaDetails, DataDefinition, DataSource } from "@/types"
import SourceSearch from "@/components/Config/Sources/SourceSearch.vue"

import { cloneDeep } from "lodash"
import api from "@/services/api"

import StringValidation from "@/scripts/stringValidation"

const setup = namespace("setup")

@Component({
	components: {
		"source-search": SourceSearch
	}
})
export default class Areas extends Vue {
	@Getter("getIsSuiteEnabled") isSuiteEnabled! : boolean;

	@setup.Getter("getDefinitions")
	public definitions!: DataDefinition[]

	public get areaSource () {
		return {
			id: "areas",
			title: "Areas",
			extraFields: [
				{
					key: "title",
					label: "Title",
					readonly: this.isSuiteEnabled,
					errors: (item: { title: string }) => StringValidation.validateTitle(item.title)
				},
				{ key: "address", label: "Address", dataType: "text-area", readonly: this.isSuiteEnabled },
				{ key: "location", label: "Location", dataType: "map-marker", readonly: this.isSuiteEnabled }],
			noEdit: true,
			hideUpload: true,
			definitionId: this.definitions ? this.areaDefinitionId : null,
			createItemModalTitle: "Create Area",
			getItems: () => api.areas(),
			itemDetails: (item: Area) => api.area(item.id),
			save: (newLocation: AreaDetails) => this.trySaveArea(newLocation),
			delete: (deleteLocation: AreaDetails) => this.tryDeleteArea(deleteLocation),
			treeLayout: true,
			treeItemSelectedModalTitle: "Area",
			treeCreateItemModalTitle: "Create sub-area"
		}
	}

	public get areaDefinitionId (): string | null {
		const definition = this.definitions.find(d => d.specialType === "area")
		return definition ? definition.id! : null
	}

	async trySaveArea (newArea: AreaDetails) {
		try {
			return await api.areaSave(newArea)
		} catch (err) {
			this.$bvToast.toast(err, {
				title: `Error saving Area: ${newArea.title}`,
				variant: "danger",
				solid: true,
				autoHideDelay: 10000
			})
			if (!newArea.id) {
				return null
			}
			return api.area(newArea.id)
		}
	}

	async tryDeleteArea (area: AreaDetails) {
		try {
			await api.areaDelete(area)
		} catch (err) {
			this.$bvToast.toast(err, {
				title: `Error deleting Area: ${area.title}`,
				variant: "danger",
				solid: true,
				autoHideDelay: 10000
			})
			throw err
		}
	}
}

